import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { getServiceIcon } from '~/shared/utils'
import { Avatar } from '~/shared/components'

import { Wrapper, AvatarWrapper, ServiceIndicator } from './styles'

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'image' implicitly has an 'any' ty... Remove this comment to see the full error message
const ChannelAvatar = ({ image, alt, size, service }) => {
  const [hasError, setHasError] = useState(false)

  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  const onAvatarError = (event) => {
    setHasError(true)
  }

  const wrapperSize = size + size / 4
  const indicatorSize = size / 2

  return (
    // @ts-expect-error TS(2769) FIXME: No overload matches this call.
    <Wrapper data-testid="wrapper" size={wrapperSize}>
      {/* @ts-expect-error TS(2769) FIXME: No overload matches this call. */}
      <AvatarWrapper data-testid="wrapper-avatar" size={size}>
        {hasError ? (
          getServiceIcon(service, 'medium')
        ) : (
          <Avatar src={image} alt={alt} onError={onAvatarError} />
        )}
      </AvatarWrapper>
      {service && (
        <ServiceIndicator
          data-testid="service-indicator"
          // @ts-expect-error TS(2769) FIXME: No overload matches this call.
          size={indicatorSize}
          service={service}
        >
          {getServiceIcon(service, 'small')}
        </ServiceIndicator>
      )}
    </Wrapper>
  )
}

ChannelAvatar.propTypes = {
  image: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.number,
  service: PropTypes.string,
}

ChannelAvatar.defaultProps = {
  image: '',
  alt: 'A default avatar image',
  size: 32,
  service: null,
}

export default ChannelAvatar
